function examesPredefinidosSelecionados(exames) {
  return exames
    .filter((exame) => exame.idExame < 46)
    .map((exame) => exame.idExame.toString());
}

function outrosExamesSelecionados(exames) {
  return exames
    .filter((exame) => exame.idExame >= 46)
    .map((exame) => exame.nome);
}

export default function Insert(exames, dados, setData) {
  setData((prevState) => ({
    ...prevState,
    examesPredefinidosSelect: 1,
    examesPredefinidosExamesEProcedimentos:
      examesPredefinidosSelecionados(exames),
    outrosExamesLaboratoriais: outrosExamesSelecionados(exames),
    examesLaboratoriaisObservacao: exames[0].observacao,
  }));
}
